export { default as CoreBootAppModule } from './module';
